import { render, staticRenderFns } from "./CadastroChatSalaGrupo.vue?vue&type=template&id=2a676507&"
import script from "./CadastroChatSalaGrupo.vue?vue&type=script&lang=js&"
export * from "./CadastroChatSalaGrupo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports